import { Menu, MenuItem, alpha, styled } from '@mui/material';

export const LanguageBox = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
  padding: '8px 10px',
  borderRadius: '14px',
  cursor: 'pointer',
  height: '40px',
  transition: 'background-color 120ms ease',
  backgroundColor: alpha(theme.palette.text.primary, 0.04),
  '&:hover': {
    backgroundColor: alpha(theme.palette.text.primary, 0.08),
  },
}));

export const FlagImage = styled('img')({
  width: '20px',
  height: '14px',
  objectFit: 'cover',
  borderRadius: '2px',
});

export const LanguageLabel = styled('span')(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 500,
  color: theme.palette.text.primary,
  textTransform: 'uppercase',
}));

export const StyledMenu = styled(Menu, { shouldForwardProp: (prop) => prop !== 'disableScrollLock' })(({ theme }) => ({
  '& .MuiMenu-paper': {
    minWidth: '10rem',
    marginTop: '8px',
    borderRadius: '14px',
    border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
  },
}));

export const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected?: boolean }>(({ theme, selected }) => ({
  display: 'flex',
  gap: '10px',
  fontSize: '13px',
  fontWeight: selected ? 600 : 400,
  color: selected ? theme.palette.primary.main : theme.palette.text.primary,
  backgroundColor: selected ? alpha(theme.palette.primary.main, 0.06) : 'transparent',
  transition: 'background-color 120ms ease',
  '&:hover': {
    backgroundColor: alpha(theme.palette.text.primary, 0.04),
  },
}));
